import { Checkbox } from '@mui/material'
import React, { Fragment } from 'react'

const FormCheckboxElement = ({item}) => {
    return <Fragment>{item?.localeKey} 
    <Checkbox  />
    </Fragment>
}

export default FormCheckboxElement
